import React from 'react';

import FooterItems from './FooterItems';
const Footer = () => {
  return (
    <footer className="bg--dot">
      <FooterItems />
    </footer>
  );
};

export default Footer;
